module.exports = __webpack_public_path__ + "static/media/csjmu.d9494a9a.png";